import { Box } from "@chakra-ui/react"
import { EDITOR_MODE, useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import React from "react"
import * as AccordionUI from "./AccordionUI"

const AccordionView = (props) => {
  const { data } = props
  const [expandedIndex, setExpandedIndex] = React.useState(null)
  const { templateVariables } = useBlocksConfig()

  const handleToggleExpandedIndex = (index) => () => {
    setExpandedIndex(index === expandedIndex ? null : index)
  }

  return (
    <Content.Container flexForPrint={true}>
      <Box boxShadow="0 0 20px 0 rgba(0, 0, 0, 0.1)" backgroundColor="#fff">
        {data.cards.map((card, index) => (
          <AccordionUI.Item
            mode={EDITOR_MODE.VIEW}
            key={index}
            title={card.title}
            expanded={index === expandedIndex}
            onToggleExpand={handleToggleExpandedIndex(index)}
          >
            <BlockText html={card.html} templateContext={templateVariables} />
          </AccordionUI.Item>
        ))}
      </Box>
    </Content.Container>
  )
}

export default AccordionView
